const FILLER_WORDS = new Set(["and", "of", "the", "for", "in", "a", "an", "&"]);
const DEFAULT_NAME = "My first search";

// Server location extents arrive as "STATE: Texas" / "COUNTY: Hampden County (MA)";
// the extent type is an internal discriminator and never belongs in a name.
const EXTENT_PREFIX = /^(?:COUNTY|MSA|STATE|CITY|COUNTRY|REGION):\s*/i;

// Longest location that still reads as a short label next to the industry.
const MAX_LOCATION_CHARS = 32;

/**
 * Collapse a label to at most three words for the onboarding name placeholder.
 */
export const toThreeWordLabel = (text) => {
  const raw = String(text || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (raw.length === 0) return "";

  const meaningful = raw.filter((word) => !FILLER_WORDS.has(word.toLowerCase()));
  const words = (meaningful.length > 0 ? meaningful : raw).slice(0, 3);
  return words.join(" ");
};

const toLocationLabel = (location) => {
  const label = String(location || "")
    .replace(EXTENT_PREFIX, "")
    .replace(/\s+/g, " ")
    .trim();
  return label.length > MAX_LOCATION_CHARS ? "" : label;
};

const firstLabel = (values, toLabel) => {
  for (const value of values || []) {
    const label = toLabel(value);
    if (label) return label;
  }
  return "";
};

/**
 * Build a short suggested first-search name for the onboarding placeholder,
 * e.g. "HVAC Contractors in New York". Combines the first selected industry
 * (max three words) with the first selected location (extent prefix removed);
 * falls back to the industry alone, the location alone, then a default.
 */
export const suggestSearchName = ({
  industryInclude = [],
  locations = [],
} = {}) => {
  const industry = firstLabel(industryInclude, toThreeWordLabel);
  const location = firstLabel(locations, toLocationLabel);

  if (industry && location) return `${industry} in ${location}`;
  if (industry) return industry;
  if (location) return `${location} companies`;
  return DEFAULT_NAME;
};
